module.exports = __webpack_public_path__ + "img/bg5.421b36f5.png";